// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"af8f641e","453":"f1a1ebaf"}[chunkId] + ".chunk.js";
};